import { createSelector } from "@reduxjs/toolkit";
import { atLeastRole } from "helpers/roles";

import { configApi } from "./configAPI";

const selectConfig = configApi.endpoints.getConfig.select();

const selectTeamupReadCalendarKey = createSelector(
  [(state) => selectConfig(state).data],
  (config) => config?.TEAMUP_READ_CALENDAR_KEY,
);

export const selectCurrentEmployee = createSelector(
  [(state) => selectConfig(state).data],
  (config) => config?.currentEmployee,
);

export const selectTeamupIframe = createSelector([selectTeamupReadCalendarKey], (key) => {
  if (!key) return null;
  return `https://teamup.com/${key}?view=mw&title=AdelaideMRI%20Leave%20Calendar&showProfileAndInfo=0&showSidepanel=1&showAgendaHeader=1&showAgendaDetails=0&showYearViewHeader=1`;
});

export const selectEffectiveRole = createSelector(
  [(state) => selectConfig(state).data],
  (config) => config?.effective_role,
);

export const selectIsManager = createSelector([selectEffectiveRole], (role) => atLeastRole(role, "manager"));
